const IDENTIFICATION_STATUSES = {
  approved: 'approved',
  rejected: 'rejected'
};

export default IDENTIFICATION_STATUSES;
